var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-loading" },
    [
      _vm.loadingType == "default" ? [_vm._m(0)] : _vm._e(),
      _vm.loadingType == "image" ? [_vm._m(1)] : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loading_box_wrap" }, [
      _c("div", { staticClass: "title" }, [_vm._v("正在思考")]),
      _c("div", { staticClass: "loading_wrap" }, [
        _c("span", { staticClass: "loading_wrap__item" }),
        _c("span", { staticClass: "loading_wrap__item" }),
        _c("span", { staticClass: "loading_wrap__item" }),
        _c("span", { staticClass: "loading_wrap__item" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "image_loading_wrap" }, [
      _c("div", { staticClass: "content_wrap" }, [
        _c("span", { staticClass: "content_wrap__item" }),
        _c("span", { staticClass: "content_wrap__item" }),
        _c("span", { staticClass: "content_wrap__item" }),
        _c("span", { staticClass: "content_wrap__item" }),
        _c("span", { staticClass: "content_wrap__item" }),
        _c("span", { staticClass: "content_wrap__item" }),
        _c("span", { staticClass: "content_wrap__item" }),
        _c("span", { staticClass: "content_wrap__item" }),
        _c("span", { staticClass: "content_wrap__item" }),
        _c("span", { staticClass: "content_wrap__item" }),
        _c("span", { staticClass: "content_wrap__item" }),
        _c("span", { staticClass: "content_wrap__item" }),
        _c("span", { staticClass: "content_wrap__item" }),
      ]),
      _c("span", { staticClass: "text" }, [_vm._v("正在生成图片")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }